try {
  document.addEventListener("click", async function (e) {
    const link = e.target.closest(
      ".custom-collection-page-pagination a.page-link"
    );
    if (link) {
      e.preventDefault();
      const url = link.getAttribute("href");
      const grid = document.querySelector(".custom-collection-page-product");
      const pagination = document.querySelector(
        ".custom-collection-page-pagination"
      );
      try {
        grid.style.opacity = "0.3";
        grid.style.transition = "opacity 0.4s ease";
        const res = await fetch(url);
        const data = await res.text();
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(data, "text/html");
        const newProducts = htmlDoc.querySelector(
          ".custom-collection-page-product"
        ).innerHTML;
        const newPagination = htmlDoc.querySelector(
          ".custom-collection-page-pagination"
        ).innerHTML;
        setTimeout(() => {
          grid.innerHTML = newProducts;
          pagination.innerHTML = newPagination;
          grid.style.opacity = "1";
          window.history.pushState({}, "", url);
        }, 400);
      } catch (err) {
        console.error("Pagination AJAX error:", err);
      }
    }
  });
} catch (error) {}

try {
  const filterDrawerOpenBtn = document.querySelector(
    ".custom-collection-page-filter-sort-bar .collection-page-filter"
  );
  const filterDrawer = document.querySelector(
    ".collection-page-filter .collection-page-filter-drawer"
  );
  const filterDrawerCloseBtn = document.querySelector(
    ".filter-drawer-close-btn"
  );
  filterDrawer.style.left = "-325px";
  filterDrawerCloseBtn.style.left = "-58px";
  filterDrawerOpenBtn.addEventListener("click", (e) => {
    if (
      e.target.closest(".collection-page-filter-drawer") ||
      e.target.closest(".filter-drawer-close-btn")
    )
      return;
    filterDrawer.style.left = "0px";
    filterDrawerCloseBtn.style.left = "325px";
  });
  filterDrawerCloseBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    filterDrawer.style.left = "-325px";
    filterDrawerCloseBtn.style.left = "-58px";
  });
  let rangePriceBox = document.querySelector(
    ".collection-page-filter-price label span"
  );
  let filterRangeValue = document.querySelector(
    ".collection-page-filter-price label input"
  );
  filterRangeValue.addEventListener("change", () => {
    rangePriceBox.innerHTML = `Dhs. ${filterRangeValue.value}.00 AED`;
  });
  document.addEventListener("DOMContentLoaded", () => {
    const filterInputs = document.querySelectorAll(
      ".collection-page-filter-drawer-bottom input"
    );
    const productGrid = document.querySelector(
      ".custom-collection-page-product"
    );
    const filterBtn = document.querySelector(".collection-page-filter-btn");
    const paginationLinks = document.querySelectorAll(
      ".custom-collection-page-pagination a"
    );
    function startLoading() {
      productGrid.classList.add("is-loading");
    }
    function stopLoading() {
      productGrid.classList.remove("is-loading");
    }
    function buildParams() {
      const params = new URLSearchParams();
      filterInputs.forEach((input) => {
        if (
          (input.type === "checkbox" && input.checked) ||
          input.type === "range"
        ) {
          params.append(input.name, input.value);
        }
      });
      return params;
    }
    async function fetchFilteredProducts(url) {
      try {
        startLoading();
        const response = await fetch(url, {
          method: "GET",
          headers: { "X-Requested-With": "XMLHttpRequest" },
        });
        if (!response.ok) throw new Error("Network response was not ok");
        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, "text/html");
        const newGrid = doc.querySelector(".custom-collection-page-product");
        const newPagination = doc.querySelector(
          ".custom-collection-page-pagination"
        );
        if (newGrid) productGrid.innerHTML = newGrid.innerHTML;
        if (newPagination) {
          document.querySelector(
            ".custom-collection-page-pagination"
          ).innerHTML = newPagination.innerHTML;
        }
        stopLoading();
      } catch (error) {
        console.error("Filter fetch failed:", error);
        stopLoading();
      }
    }
    filterBtn.addEventListener("click", () => {
      const params = buildParams();
      const url = new URL(window.location.href);
      url.search = params.toString();
      window.history.pushState({}, "", url);
      fetchFilteredProducts(url);
      filterDrawer.style.left = "-325px";
      filterDrawerCloseBtn.style.left = "-58px";
    });
    document.addEventListener("click", (e) => {
      if (e.target.closest(".custom-collection-page-pagination a")) {
        e.preventDefault();
        const link = e.target.closest("a").href;
        const params = buildParams();
        const url = new URL(link);
        url.search = params.toString();
        window.history.pushState({}, "", url);
        fetchFilteredProducts(url);
      }
    });
  });
} catch (error) {}

try {
  let sortOpenBtn = document.querySelector(".collection-page-sort");
  let sortDropdown = document.querySelector(".sortbyoptionwrapper");
  sortDropdown.style.opacity = "0";
  sortDropdown.style.zIndex = "-5";
  sortOpenBtn.addEventListener("click", () => {
    if (sortDropdown.style.opacity == "0") {
      sortDropdown.style.opacity = "1";
      sortDropdown.style.zIndex = "15";
    } else if (sortDropdown.style.opacity == "1") {
      sortDropdown.style.opacity = "0";
      sortDropdown.style.zIndex = "-5";
    }
  });
  document.addEventListener("DOMContentLoaded", () => {
    const filterInputs = document.querySelectorAll(
      ".collection-page-filter-drawer-bottom input"
    );
    const productGrid = document.querySelector(
      ".custom-collection-page-product"
    );
    const filterBtn = document.querySelector(".collection-page-filter-btn");
    const paginationWrapper = document.querySelector(
      ".custom-collection-page-pagination"
    );
    const sortOptions = document.querySelectorAll(".sortbyoption");
    function startLoading() {
      productGrid.classList.add("is-loading");
      productGrid.style.opacity = "0.3";
      productGrid.style.transition = "opacity 0.4s ease";
    }
    function stopLoading() {
      productGrid.classList.remove("is-loading");
      productGrid.style.opacity = "1";
    }
    function buildParams() {
      const params = new URLSearchParams();
      filterInputs.forEach((input) => {
        if (
          (input.type === "checkbox" && input.checked) ||
          input.type === "range"
        ) {
          params.append(input.name, input.value);
        }
      });
      const activeSort = document.querySelector(".sortbyoption.active");
      if (activeSort) {
        params.set("sort_by", activeSort.getAttribute("value"));
      }
      return params;
    }
    async function fetchProducts(url) {
      try {
        startLoading();
        const response = await fetch(url, {
          method: "GET",
          headers: { "X-Requested-With": "XMLHttpRequest" },
        });
        if (!response.ok) throw new Error("Network response was not ok");
        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, "text/html");
        const newGrid = doc.querySelector(".custom-collection-page-product");
        const newPagination = doc.querySelector(
          ".custom-collection-page-pagination"
        );
        if (newGrid) productGrid.innerHTML = newGrid.innerHTML;
        if (newPagination && paginationWrapper) {
          paginationWrapper.innerHTML = newPagination.innerHTML;
        }
        stopLoading();
      } catch (error) {
        console.error("Fetch failed:", error);
        stopLoading();
      }
    }
    filterBtn.addEventListener("click", () => {
      const params = buildParams();
      const url = new URL(window.location.href);
      url.search = params.toString();
      window.history.pushState({}, "", url);
      fetchProducts(url);
    });
    document.addEventListener("click", (e) => {
      if (e.target.closest(".custom-collection-page-pagination a")) {
        e.preventDefault();
        const link = e.target.closest("a").href;
        const params = buildParams();
        const url = new URL(link);
        url.search = params.toString();
        window.history.pushState({}, "", url);
        fetchProducts(url);
      }
    });
    sortOptions.forEach((option) => {
      option.addEventListener("click", () => {
        sortOptions.forEach((opt) => opt.classList.remove("active"));
        option.classList.add("active");
        const params = buildParams();
        const url = new URL(window.location.href);
        url.search = params.toString();
        window.history.pushState({}, "", url);
        fetchProducts(url);
      });
    });
  });
} catch (error) {}
